import React from 'react'
import { Close, HeaderWrapper, Title } from './HeaderStyles'
import { Header_Props } from './interface'
import { ReactComponent as CloseSVG } from '../../lib/assets/close.svg'
import { SFXS } from '@orbital/games-frontend-library'

export default function PageHeader({ title, func, audio }: Header_Props) {
  return (
    <HeaderWrapper>
      <Title>{title}</Title>
      <Close onClick={() => func()}>
        <div className='btn'>
          <CloseSVG />
        </div>
      </Close>
    </HeaderWrapper>
  )
}
